
class OperationSizeConstants
{
  static dateCellWidth = '8%';
  static editCellWidth = '3%';
  static sumCellWidth = '12%';
  static categoryCellWidth = '17%';
  static subcategoryCellWidth = '15%';
  static tagCellWidth = '17%';
  static descCellWidth = '15%';
  static accountCellWidth = '13%';
}

export {OperationSizeConstants}
